import {useSelector, useDispatch} from "react-redux";
import {GET_MODAL, SET_MODAL} from "@/store/slices/appSlice";
import Overlay from "@/components/overlay";
import ErroProcessamento from "@/components/modals/erroProcessamento";
import ImpossibilidadeEntrega from "@/components/modals/impossibilidadeEntrega";
import SumarioDoContrato from "./sumarioDoContrato";
import PedidoDuplicado from "@/components/modals/pedidoDuplicado";
import EmailJaCadastrado from "@/components/modals/emailJaCadastrado";
import AtualizarTelefone from "@/components/modals/atualizarTelefone";
import UsuarioAssinante from "./usuarioAssinante";
import GenericError from "@/components/modals/genericError";
import MudancaPreco from "./mudancaPreco";

export default function Modals() {
    const modal = useSelector(GET_MODAL)
    const dispatch = useDispatch()
    
    return (
        <Overlay className={modal.show ? 'show' : ''} bg={'#39393f99'} >
            <div style={{width:'100vw', height:'100vh', position:'absolute'}} onClick={()=>dispatch(SET_MODAL({type:null, show:false}))}/>
            {(modal.show && modal.type === 'falha-pagamento') && <ErroProcessamento></ErroProcessamento>}
            {(modal.show && modal.type === 'generic-error') && <GenericError></GenericError>}
            {(modal.show && modal.type === 'usuario-assinante') && <UsuarioAssinante></UsuarioAssinante>}
            {(modal.show && modal.type === 'impossibilidade') && <ImpossibilidadeEntrega></ImpossibilidadeEntrega>}
            {(modal.show && modal.type === 'mudanca-preco' && modal.price) && <MudancaPreco data={modal.price}></MudancaPreco>}
            {(modal.show && modal.type === 'sumario') && <SumarioDoContrato></SumarioDoContrato>}
            {(modal.show && modal.type === 'pagamento-duplicado') && <PedidoDuplicado></PedidoDuplicado>}
            {(modal.show && modal.type === 'email-ja-cadastrado' && modal.email) && <EmailJaCadastrado data={modal.email}></EmailJaCadastrado>}
            {(modal.show && modal.type === 'atualizar-telefone') && <AtualizarTelefone></AtualizarTelefone>}
        </Overlay>
    )
}
